import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import ActivateIcon from '@mui/icons-material/CheckCircle'; // Import the activate icon
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';


function ProductIndex() {
  const [data, setData] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  // const [searchTerm, setSearchTerm] = useState('');
  // const [filteredData, setFilteredData] = useState([]);
  const history = useHistory(); // Access the navigation history

  const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
  const hasCreateMasterPermission = permissions.includes('Create Master');
  const hasEditMasterPermission = permissions.includes('Edit Master');
  const hasDeleteMasterPermission = permissions.includes('Delete Master');

  useEffect(() => {
    // Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user
      logout();
      return;
    }

    // Token is not expired, fetch data
    fetchtableData();
  }, [isAuthenticated, companyId, token, logout]);

  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchInput, setShowSearchInput] = useState(false);
  //handle search
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const toggleSearchInput = () => {
    setShowSearchInput(!showSearchInput);
  };

  //search
  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const fetchtableData = async () => {
    fetchData('ProductApi', `/${companyId}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setData(response.response_data);

        }
      })
      .catch((error) => {
        console.error('Error fetching Item Details:', error);
        // Handle error, e.g., redirect to login if token is expired
        if (error.response && error.response.status === 401) {
          logout();
          // Redirect to login with the current location as a parameter
          history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
        }
      });
  };

  const handleDelete = async () => {
    deleteData('ProductApi', `${deleteItemId}`)
      .then((response) => {
        fetchtableData();
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
      });
  };

  const handleActivate = (itemId) => {
    activateData('ProductApi', `${itemId}`)
      .then(() => {
        fetchtableData();
      })
      .catch((error) => {
        console.error('Error activating record:', error);
      });
  };

  const openConfirmDialog = (itemId) => {
    setDeleteItemId(itemId);
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setDeleteItemId(null);
    setConfirmDialogOpen(false);
  };

  return (
    <div className="w-full max-w-sm container mt-2 mx-auto">
      <div className='w-full mb-2 flex'>
        <h3 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>PRODUCT</h3>
        {/* {hasCreateMasterPermission && ( */}
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/ProductCreate"
          className="linkcolor"
          style={{ marginLeft: '8px' }}
        >
          CREATE
        </Button>
        {/* )} */}

      </div>

      <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>

        <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
        {showSearchInput && (
          <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearch}
            style={{ marginLeft: '10px', width: '200px' }}
          />
        )}
      </div>

      <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: '#1E9694' }}>
              <TableRow>
                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', fontWeight: 'bolder', color: 'white' }}>Product</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', fontWeight: 'bolder', color: 'white' }}>Brand</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', fontWeight: 'bolder', color: 'white' }}>Category</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', fontWeight: 'bolder', color: 'white' }}>Description</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', fontWeight: 'bolder', color: 'white' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ backgroundColor: '#BAEAEB' }}>
              {filteredData.map(item => (
                <TableRow key={item.id} className={item.isActive ? '' : 'inactiveRow'}>
                  <TableCell sx={{ height: '20px', padding: '5px', fontSize: '16px' }}>{item.name}</TableCell>
                  <TableCell sx={{ height: '20px', padding: '5px', fontSize: '16px' }}>{item.brand}</TableCell>
                  <TableCell sx={{ height: '20px', padding: '5px', fontSize: '16px' }}>{item.category}</TableCell>
                  <TableCell sx={{ height: '20px', padding: '5px', fontSize: '16px' }}>{item.description}</TableCell>

                  <TableCell sx={{ height: '20px', padding: '5px' }}>

                    {/* {hasEditMasterPermission && ( */}
                    <Link to={`/ProductEdit/${item.id}`}>
                      <IconButton>
                        <EditIcon />
                      </IconButton>
                    </Link>
                    {/* )} */}
                    {/* {hasDeleteMasterPermission && ( */}
                    <IconButton onClick={() => (item.isActive ? openConfirmDialog(item.id) : handleActivate(item.id))}>
                      {item.isActive ? <DeleteIcon /> : <ActivateIcon />}
                    </IconButton>
                    {/* )} */}

                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <Dialog
              open={confirmDialogOpen}
              onClose={closeConfirmDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to delete this record?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <button
                  onClick={closeConfirmDialog}
                  style={{
                    backgroundColor: '#dc3545',
                    color: '#ffffff',
                    border: '1px solid #dc3545',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    marginRight: '8px',
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleDelete}
                  style={{
                    backgroundColor: '#28a745',
                    color: '#ffffff',
                    border: '1px solid #28a745',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                  }}
                >
                  Confirm
                </button>
              </DialogActions>
            </Dialog>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}


export default ProductIndex;

